import styled from '@emotion/styled';
import React from 'react';

import ActionButton from '../ActionButton/ActionButton';
import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WarningModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n();
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <h2>{t(TranslationKeys.general_document_delete_warning_title)}</h2>
        <ActionButton
          variant="accept-blue"
          buttonText={t(TranslationKeys.general_document_ok_button)}
          onClickAction={onClose}
        />{' '}
      </ModalContent>
    </ModalOverlay>
  );
};

export default WarningModal;
